<template>
  <div>
    <GroupOrderHeaderBand
      :sectionDescription="
        'Please review your order to make sure all information is accurate before confirming.'
      "
      :showFixedHeader="true"
    />

    <section class="section-holder">
      <div class="arrow-link margin">
        <router-link :to="{ name: 'GroupOrderRecipientForm' }">
          <span>Back</span>
        </router-link>
      </div>

      <div class="group-order-container">
        <GroupOrderRecipientInfo :recipient="recipient" />
        <GroupOrderCartList :selectedVariants="selectedVariants" />
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GroupOrderHeaderBand from './GroupOrderHeaderBand'
import GroupOrderRecipientInfo from './GroupOrderRecipientInfo'
import GroupOrderCartList from './GroupOrderCartList'

export default {
  name: 'GroupOrderConfirmation',
  components: {
    GroupOrderHeaderBand,
    GroupOrderRecipientInfo,
    GroupOrderCartList
  },
  created() {
    // this.$store.dispatch('layout/setPageLayout', layouts.GROUP_ORDER_LAYOUT)
    this.$store.dispatch('groupOrder/getRecipientSelectedItems')
  },
  computed: {
    ...mapState({
      recipient: state => state.groupOrder.recipient,
      selectedVariants: state => state.groupOrder.selectedVariants
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.arrow-link {
  margin-top: 4rem;
}

.section-holder {
  width: 80%;
  margin: 2rem auto;
  display: flex;
  position: relative;
  top: 5rem;
}

@media (max-width: 1150px) {
  .arrow-link {
    position: inherit;
    left: 0;
    top: 0rem;
  }

  .group-order-container {
    width: 85%;
  }
}

@media (max-width: 575.98px) {
  .group-order-container {
    width: 100%;
    padding: 1rem 1.5rem 5rem 1.5rem;
    margin: 2rem auto;
  }

  .section-holder {
    width: 100%;
    flex-wrap: wrap;
    margin: 2rem auto;
  }

  .arrow-link {
    margin-left: 1rem;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .group-order-container {
    width: 100%;
    padding: 1rem 1.5rem 5rem 1.5rem;
    margin: 2rem auto;
  }

  .section-holder {
    width: 100%;
    flex-wrap: wrap;
    margin: 2rem auto;
  }

  .arrow-link {
    margin-left: 1rem;
  }
}
</style>
